import Sortable from 'sortablejs';
import { initCardIdAutocomplete, initSimpleCardAutocomplete } from './search';

window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {
  const slidesContainer = document.querySelector('.deck-tech-slides-sortable');
  if (slidesContainer) {
    Sortable.create(slidesContainer, { handle: '.drag-handle' });
  }

  document.querySelector('.deck-techs-add-card')?.addEventListener('click', function() {
    const template = document.getElementById('deck-tech-slide-new-card-insertion');
    const insertion = document.getElementById('deck-tech-slide-new-slide-insertion');
    Array.from(template.cloneNode(true).children).forEach(child => {
      insertion.insertAdjacentElement('beforebegin', child);
    });
    rebindAutocomplete();
  });

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.deck-techs-add-card-to-slide');
    if (!btn) return;
    const slide = btn.closest('.deck-tech-slide');
    const cloneable = slide?.querySelector('.cloneable-card');
    if (!cloneable) return;
    for (let i = 0; i < 4; i++) {
      const clone = cloneable.cloneNode(true);
      clone.classList.remove('cloneable-card');
      cloneable.insertAdjacentElement('beforebegin', clone);
    }
    rebindAutocomplete();
  });

  document.querySelector('.deck-techs-add-deck')?.addEventListener('click', function() {
    const template = document.getElementById('deck-tech-slide-new-deck-insertion');
    const insertion = document.getElementById('deck-tech-slide-new-slide-insertion');
    Array.from(template.cloneNode(true).children).forEach(child => {
      insertion.insertAdjacentElement('beforebegin', child);
    });
    rebindAutocomplete();
  });

  document.querySelector('.deck-techs-add-image')?.addEventListener('click', function() {
    const template = document.getElementById('deck-tech-slide-new-image-insertion');
    const insertion = document.getElementById('deck-tech-slide-new-slide-insertion');
    Array.from(template.cloneNode(true).children).forEach(child => {
      insertion.insertAdjacentElement('beforebegin', child);
    });
  });

  document.querySelector('.deck-techs-form')?.addEventListener('submit', preprocessForm);

  document.addEventListener('click', function(e) {
    const icon = e.target.closest('.deck-techs-slide-delete-icon');
    if (!icon) return;
    const row = icon.closest('.row');
    if (!row) return;
    row.style.display = 'none';
    const checkbox = row.querySelector('.deck-techs-slide-delete');
    if (checkbox) checkbox.checked = true;
  });

  document.getElementById('deck_input_specific_cards')?.addEventListener('change', function() {
    rebindAutocomplete();
  });
});

function preprocessForm(e) {
  let i = 0;
  document.querySelectorAll('.deck-techs-form .deck-tech-slide').forEach(slide => {
    slide.querySelector('.deck-tech-slide-position').value = i;
    slide.querySelectorAll(':input').forEach(input => {
      const name = input.getAttribute('name');
      if (name) input.setAttribute('name', name.replace(/\[\d+\]/, '[' + i + ']'));
    });
    i++;
  });
}

function rebindAutocomplete() {
  const specificCards = document.getElementById('deck_input_specific_cards');
  document.querySelectorAll('.deck-techs-form input.autocomplete-card, .deck-techs-form textarea.autocomplete-card, .deck-techs-form select.autocomplete-card, .deck-techs-form input.autocomplete-card-id, .deck-techs-form textarea.autocomplete-card-id, .deck-techs-form select.autocomplete-card-id').forEach(el => {
    if (el.tomselect) el.tomselect.destroy();

    if (specificCards?.checked) {
      el.classList.remove('autocomplete-card');
      el.classList.add('autocomplete-card-id');
      initCardIdAutocomplete(el);
    } else {
      el.classList.remove('autocomplete-card-id');
      el.classList.add('autocomplete-card');
      initSimpleCardAutocomplete(el);
    }
  });
}
window.rebindAutocomplete = rebindAutocomplete;
